import { memo } from 'react';

const PageNotFound = () => {
  return (
    <div className="page-not-found">
      <img src="/error.svg" alt="something went wrong" />
      <div className="page-not-found__content">
        <h1 className="">404. Page Not found.</h1>
        <div className="">The Page you are looking for does not exist.</div>
        <a href="/" className="btn btn-outline-primary rounded-pill">
          Back to Home
        </a>
      </div>
    </div>
  );
};

export default memo(PageNotFound);
